export const BillingTableData = {
  header: [
    {
      label: "",
      key: "check",
    },
    {
      label: "Trip Date",
      key: "tripDate",
    },

    {
      label: "Booking ID",
      key: "bookingId",
    },
    {
      label: "Company",
      key: "company",
    },
    {
      label: "Passenger",
      key: "passenger",
    },
    {
      label: "Rep. Time",
      key: "repTime",
    },
    {
      label: "Duty Type",
      key: "dutyType",
    },
    {
      label: "Rep. Address",
      key: "repAddress",
    },
    {
      label: "Drop Address",
      key: "dropAddress",
    },
    {
      label: "Status",
      key: "status",
    },
    {
      label: "",
      key: "icon",
    },
  ],
  body: [
    {
      id:'fbvjfvjbfj',
      tripDate: "25/08/2023",
      bookingId: "BLR 156",
      company: "Gloify",
      passenger: "Gokul V",
      repTime: "07:00 PM",
      dutyType: "Airport Transfer",
      repAddress: "#21/A veeranjenaya temple road",
      dropAddress: "#21/A veeranjenaya temple road",
      status: "Billed",
      personType: "normal",
      amount: 20,
    },
    {
      id:'fbvjfvjbfd',
      tripDate: "25/08/2023",
      bookingId: "BLR 156",
      company: "Gloify",
      passenger: "Gokul V",
      repTime: "07:00 PM",
      dutyType: "Airport Transfer",
      repAddress: "#21/A veeranjenaya temple road",
      dropAddress: "#21/A veeranjenaya temple road",
      status: "Billed",
      personType: "normal",
      amount: 40,
    },
    {
      id:'fbvjfvjbff',
      tripDate: "25/08/2023",
      bookingId: "BLR 156",
      company: "Gloify",
      passenger: "Gokul V",
      repTime: "07:00 PM",
      dutyType: "Airport Transfer",
      repAddress: "#21/A veeranjenaya temple road",
      dropAddress: "NA",
      status: "Billed",
      personType: "Vip",
      amount: 80,
    },
    {
      id:'fbvjfvjbfh',
      tripDate: "25/08/2023",
      bookingId: "BLR 156",
      company: "Gloify",
      passenger: "Gokul V",
      repTime: "07:00 PM",
      dutyType: "Airport Transfer",
      repAddress: "#21/A veeranjenaya temple road",
      dropAddress: "#21/A veeranjenaya temple road",
      status: "Billed",
      personType: "normal",
      amount: 30,
    },
    {
      id:'fbvjfvjbfk',
      tripDate: "25/08/2023",
      bookingId: "BLR 156",
      company: "Gloify",
      passenger: "Gokul V",
      repTime: "07:00 PM",
      dutyType: "Airport Transfer",
      repAddress: "#21/A veeranjenaya temple road",
      dropAddress: "#21/A veeranjenaya temple road",
      status: "Billed",
      personType: "normal",
      amount: 50,
    },
    {
      id:'fbvjfvjbfl',
      tripDate: "25/08/2023",
      bookingId: "BLR 156",
      company: "Gloify",
      passenger: "Gokul V",
      repTime: "07:00 PM",
      dutyType: "Airport Transfer",
      repAddress: "#21/A veeranjenaya temple road",
      dropAddress: "NA",
      status: "Billed",
      amount: 100,
    },
  ],
};

export const rejectFormData = {
  "":[
    {
      textField: true,
      gridSize: 12,
      required: true,
      star: "*",
      placeholder: "Reject Reason",
      type: "text",
      name: "Reject Reason",
      label: "Reject Reason",
      multiline: true,
    }
  ]
}
